import angular from 'angular';

import Component from './event-flyout.component';

const Module = angular
    .module('control-room.commons.basic.components.event-flyout', [])
    .component('crEventFlyout', Component);

export default Module;
